import { jsx as _jsx } from "react/jsx-runtime";
import { GalleryLabelsContainer } from './styles/gallery-labels.styled';
export const GalleryLabels = ({ labels }) => (_jsx(GalleryLabelsContainer, { className: "PONCHO-gallery__labels", children: labels }));
